import React from "react";
import { useNavigate } from "react-router-dom";
import { AlertTriangle, UserPlus } from "lucide-react";
import { colors } from "../styles/index";
import { useProfile } from "../context/ProfileContext";

// Shown inside a try-it org (from logistics-workflow): what a demo is, and the way out to a real account.
export default function DemoOrgBanner({ logout }) {
  const navigate = useNavigate();
  const { profile } = useProfile();
  if (!profile?.org?.is_demo) return null;

  const handleSignUp = () => {
    // eslint-disable-next-line no-alert
    if (!window.confirm("Signing up ends this demo - its plans and simulations are deleted. Continue?")) return;
    logout();
    setTimeout(() => navigate("/register", { replace: true }), 0);
  };

  return (
    <div
      role="status"
      style={{ display: "flex", alignItems: "center", flexWrap: "wrap", gap: 12, padding: "12px 16px", marginBottom: 12,
        background: "#FFF7ED", border: "1px solid #F59E0B", borderLeft: "4px solid #F59E0B", borderRadius: 8,
        fontSize: "0.9rem", color: colors.textDark }}
    >
      <AlertTriangle size={16} color="#F59E0B" style={{ flexShrink: 0 }} />
      <span style={{ flex: 1 }}>
        <strong>Demo</strong> - a temporary workspace with template simulations. A few AI steps are included; everything is deleted
        when the session ends. <strong>Don&rsquo;t upload confidential documents.</strong>
      </span>
      <button
        type="button"
        onClick={handleSignUp}
        style={{ display: "inline-flex", alignItems: "center", gap: 4, background: colors.primary, color: "white", border: "none",
          padding: "6px 12px", borderRadius: 4, cursor: "pointer", fontSize: "0.9rem", fontWeight: 500, whiteSpace: "nowrap" }}
      >
        <UserPlus size={14} />
        Sign up for your team
      </button>
    </div>
  );
}
